<template>
	<div>
		<div class="contact-info">
			<div class="contact-info-image">
				<img :src="cover" alt="Kategori" />
			</div>
			<TextField alignment="left" class="contact-info-text">
				<slot />
			</TextField>
		</div>
	</div>
</template>

<script>
import TextField from '@/components/TextField'

export default {
	props: {
		cover: {
			type: String,
			default: '',
		},
	},

	mounted() {},
	components: {
		TextField,
	},
}
</script>
<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';
.contact-info {
	&-text {
		padding: 1rem 3.3rem 4rem 3.3rem;
	}
	&-image {
		max-width: 100%;
		overflow: hidden;
		@include respond-below('phone') {
			border-radius: 0px;
		}
		border-radius: 0 4px 0 0;
		img {
			width: 100%;
			object-fit: contain;
		}
	}
}
</style>
